module.exports = __webpack_public_path__ + "static/media/sf-test-2.412eb1c7.mp3";